import { createContext, useContext, useMemo } from "react";

type InputContext =
  | [
      { [key: string]: unknown },
      React.Dispatch<{ inputName: string; value: unknown }>,
      (inputName: string) => string | null,
    ]
  | null;

const context = createContext<InputContext>(null);

export function useInput<T>(
  path: string,
): [T, (newVal: T) => void, string | null] {
  const reducer = useContext(context);

  if (!reducer) {
    throw new Error("useInput must be used within a Context");
  }

  const [values, dispatch, getError] = reducer;

  const value = useMemo(() => {
    return values[path];
  }, [values, path]);

  const onChange = (newVal: unknown) => {
    dispatch({
      inputName: path,
      value: newVal,
    });
  };

  const error = typeof getError === "function" && getError(path);

  return [value as T, onChange, error || null];
}
